<template>
  <div class="info-account">
    <TablePagination
      v-if="loading"
      ref="InfoAccount"
      :form-config="tableFormConfig"
      :columns="columns"
      :url="api"
      :params-formatter="paramsFormatter"
      :headerRenderConfig="{
        create: {
          text: '添加新成员',
          click: () => handleBtnInfo('', 'create'),
        },
        deliver: {
          text: '转交管理员',
          click: () => handleBtnInfo('', 'deliver'),
          auth: () => {
            return (
              userInfo.company &&
              userInfo.company.company_employer.is_admin === 1
            );
          },
        },
      }"      
      class="filter-form-custom"
    >
    <!-- :tabelRenderConfig="{
      distribution: {
        text: '分配权益',
        click: (row) => handleBtnInfo(row, 'distribution'),
      },
      delete: {
        text: '移出企业',
        click: (row) => handleBtnInfo(row, 'delete'),
        auth: (row) => {
          return (
            row.is_admin !== 1 &&
            userInfo.company &&
            userInfo.company.company_employer.is_admin === 1
          );
        },
      },
    }" -->
      <el-table-column
        label="职位刷新剩余"
      >
        <template slot-scope="scope">
          <label class="operate-item" @click="handleViewInfo(scope.row,'职位刷新点',scope.row.post_refresh_point,5)">
            {{scope.row.post_refresh_point < 0 ? "剩余全部" : scope.row.post_refresh_point}}
          </label>
        </template>
      </el-table-column>
      <el-table-column
        label="职位置顶剩余"
      >
        <template slot-scope="scope">
          <label class="operate-item" @click="handleViewInfo(scope.row,'职位置顶点',scope.row.post_top_point,3)">
            {{scope.row.post_top_point < 0 ? "剩余全部" : scope.row.post_top_point}}
          </label>
        </template>
      </el-table-column>
      <el-table-column
        label="省心推剩余"
      >
        <template slot-scope="scope">
          <label class="operate-item" @click="handleViewInfo(scope.row,'职位省心推',scope.row.post_push_point,6)">
            {{scope.row.post_push_point < 0 ? "剩余全部" : scope.row.post_push_point}}
          </label>
        </template>
      </el-table-column>
      <el-table-column
        label="简历下载剩余"
      >
        <template slot-scope="scope">
          <label class="operate-item" @click="handleViewInfo(scope.row,'简历下载点',scope.row.resume_download_num,4)">
            {{scope.row.resume_download_num < 0 ? "剩余全部" : scope.row.resume_download_num}}
          </label>
        </template>
      </el-table-column>
      <el-table-column
        label="加入时间"
        width="180px"
      >
        <template slot-scope="scope">
          <label>
            {{scope.row.add_time}}
          </label>
        </template>
      </el-table-column>
      <el-table-column
        label="角色"
      >
        <template slot-scope="scope">
          <label>
            {{scope.row.is_admin === 1 ? "管理员" : "成员"}}
          </label>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="160px"
      >
        <template slot-scope="scope">
          <label
            v-if="scope.row.mobile!=userInfo.mobile"
            class="sure-color-option"
            @click="handleBtnInfo(scope.row,'distribution')"
          >
            分配权益
          </label>
          <label
            v-if="scope.row.is_admin !== 1 &&
              userInfo.company &&
              userInfo.company.company_employer.is_admin === 1"
            class="del-color-option"
            @click="handleBtnInfo(scope.row,'delete')"
          >
            移出企业
          </label>
        </template>
      </el-table-column>
    </TablePagination>

    <DialogFormCustom
      v-model="formData"
      title="添加新成员"
      :visible.sync="formDialogShow"
      :form-config="formConfig"
      :rules="rules"
      label-position="right"
      diaWidth="468px"
      @confirm="(data) => handleConfirm('create', data)"
    >
      <template slot="before">
        <div class="form-config">
          <div class="title">方式一：您可分享下方链接给其他成员自行注册</div>
          <div class="copy-item">
            <span>zp.dcthq.com</span>
            <a @click="handleConfirm('copy')">复制链接</a>
          </div>
          <div class="title">
            方式二：直接添加成员，TA可通过短信验证码方式进行登录
          </div>
        </div>
      </template>
    </DialogFormCustom>

    <DialogFormCustom
      v-model="deliverFormData"
      title="转交管理员"
      :visible.sync="deliverFormDialogShow"
      :form-config="deliverFormConfig"
      :rules="deliverRules"
      :buttons="deliverButtons"
      @confirm="(data) => handleConfirm('deliver', data)"
    >
      <template slot="before">
        <div class="deliver-form-config-before">
          请选择要转交为新管理员的成员
          <span>
            若无人员选择，可先添加成员，或邀请对方注册成为地产同行圈的招聘者
          </span>
        </div>
      </template>
      <template slot="after">
        <div class="deliver-form-config-after">
          转交后，你将失去管理员的权限，对应权限将转交给对方。
        </div>
      </template>
    </DialogFormCustom>

    <DialogDelCustom
      v-model="delDialogShow"
      :title="deleteTitle"
      label="移出后，TA账号下的所有职位、简历将自动转移至您的账号内，TA所剩余未使用的招聘权益也将自动释放回企业中"
      :buttons="delButtons"
      @confirm="(data) => handleConfirm('delete', data)"
    />

    <!-- <DialogFormCustom
      v-model="distributionFormData"
      :title="distributionTitle"
      :visible.sync="distributionFormDialogShow"
      :form-config="distributionFormConfig"
      :rules="distributionRules"
      @confirm="(data) => handleConfirm('distribution', data)"
    > -->
    <el-dialog
      :visible.sync="distributionFormDialogShow"
      :title="distributionTitle"
      width="450px"
      class="distributionDia"
    >
      <div class="distributionDia-content">
        <div class="title">注：可分配数量仅可从您个人权益剩余中扣减（不含他人分配给您的）</div>
        <div class="citysChose">
          <el-select v-model="city_value" placeholder="请选择" @change="changeCitys">
            <el-option
              v-for="item in city_options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-form ref="form" :model="detail" :rules="distributionRules" label-width="36px">
          <div class="item">
            职位置顶点
            <span>（可分配：{{modal.idnumber}}）</span>
          </div>
          <el-form-item label="总共：">
            <el-input v-model="formModal.idnumber" placeholder="请输入要分配的数量"></el-input>
          </el-form-item>
          <div class="item">
            职位刷新点
            <span>（可分配：{{modal.idnumber1}}）</span>
          </div>
          <el-form-item label="总共：">
            <el-input v-model="formModal.idnumber1" placeholder="请输入要分配的数量"></el-input>
          </el-form-item>
          <div class="item">
            职位省心推
            <span>（可分配：{{modal.idnumber2}}）</span>
          </div>
          <el-form-item label="总共：">
            <el-input v-model="formModal.idnumber2" placeholder="请输入要分配的数量"></el-input>
          </el-form-item>
          <div class="item">
            简历下载点
            <span>（可分配：{{modal.idnumber3}}）</span>
          </div>
          <el-form-item label="总共：">
            <el-input v-model="formModal.idnumber3" placeholder="请输入要分配的数量"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="distributionFormDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm('distribution',formModal)">保 存</el-button>
      </div>
    </el-dialog>
    <div v-if="numberFlag" class="number-kf"> 
      <div class="number-kf-title">
        <span>{{numberName}}：共 {{numberSurplus}} 点</span>  
        <img class="icon" :src="require('$img/company-close.png')" alt="" @click="numberFlag=false">
      </div>
      <el-table
        :data="tableData"
        class="nunmber-table"
        style="width: 100%">
        <el-table-column
          prop="province"
          label="地区">
        </el-table-column>
        <el-table-column
          prop="surplus"
          label="剩余数量">
        </el-table-column>
      </el-table>
    </div>
    
    <!-- </DialogFormCustom> -->
  </div>
</template>

<script>
import TablePagination from "@/components/TablePagination";
import DialogFormCustom from "@/components/DialogFormCustom";
import DialogDelCustom from "@/components/DialogDelCustom";
import {
  validateInputInteger,
  validateInputNumber,
} from "@/components/FormCustom/rule";

import { mapState } from "vuex";

import {
  columns,
  tableFormConfig,
  rules,
  formConfig,
  api,
  deliverFormConfig,
  deliverRules,
  distributionFormConfig,
  distributionRules,
} from "./define.js";
/**
 * 成员管理
 * @author zhouyingchao
 */
export default {
  name: "InfoAccount",
  components: {
    TablePagination,
    DialogFormCustom,
    DialogDelCustom,
  },
  data() {
    return {
      rules,
      formConfig,
      formData: {},
      formDialogShow: false,
      deliverFormData: {},
      deliverFormDialogShow: false,
      deliverFormConfig: [],
      deliverRules,
      deliverButtons: {
        cancel: {
          text: "取消",
        },
        confirm: {
          text: "确认转交",
          disabled: true,
        },
      },
      delDialogShow: false,
      deleteTitle: "",
      delButtons: {
        cancel: {
          text: "取消",
        },
        confirm: {
          text: "确认移除",
        },
      },
      distributionFormData: {},
      distributionFormDialogShow: false,
      distributionFormConfig: [],
      distributionRules,
      distributionTitle: "",
      loading: false,
      columns: [],
      api,
      tableFormConfig: [],
      info: null,
      produc: {},
      detail:{
        quota:{},
        surplus:{}
      },  //分配详情
      modal:{
        idnumber:"",
        idnumber1:"",
        idnumber2:"",
        idnumber3:"",
      },
      formModal:{
        idnumber:"",
        idnumber1:"",
        idnumber2:"",
        idnumber3:"",
      },
      numberFlag:false,
      numberName:'',
      numberSurplus:0,
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
      }, {
        date: '2016-05-04',
        name: '王小虎',
      }], 
      pagination: {
        total: 0,
        page: 1,
        count: 20
      },
      city_options:[],
      city_value:'',
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  watch: {
    deliverFormData: {
      deep: true,
      handler(val) {
        if (val.id && val.id[0]) {
          this.deliverButtons = {
            cancel: {
              text: "取消",
            },
            confirm: {
              text: "确认转交",
              disabled: false,
            },
          };
        } else {
          this.deliverButtons = {
            cancel: {
              text: "取消",
            },
            confirm: {
              text: "确认转交",
              disabled: true,
            },
          };
        }
      },
    },
  },
  async created() {
    this.columns = columns;
    this.tableFormConfig = tableFormConfig;
    this.loading = true;
    this.loadUsers();
    setTimeout(() => {
      this.$refs["InfoAccount"].$refs.formCustom.handleExpectQuery();
    }, 200);
  },
  async mounted() {
    // this.$refs["RightsRecord"].$refs.formCustom.handleExpectQuery();
  },
  methods: {
    async loadUsers() {
      const res = await this.$axios.post("/recruitment/company/employer_list");
      const options = res.data.items
        .filter((item) => item.id !== this.userInfo.id)
        .map((item) => {
          let tel = item.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
          return {
            label: item.name + " " + tel,
            value: item.employer_id,
          };
        });
      this.deliverFormConfig = deliverFormConfig(options);
    },
    async loadProduct(id) {
      const res = await this.$axios.post("/recruitment/company/product", {
        vision_user_id: id,
      });
      this.produc = res.data;
    },
    changeCitys(){
      // console.log(this.detail.quota,this.city_options)
      this.dataFlas(this.detail.quota,this.detail.surplus);
    },
    // 获取分配详情
    async distributeRightsDetail(id) {
      this.numberFlag=false;      
      const res = await this.$axios.post("/recruitment/company/distribute_rights_detail", {
        vision_user_id: id,
      });
      this.detail = res.data;
      let quota=res.data.quota;
      let surplus=res.data.surplus
      this.dataFlas(quota,surplus);
      this.modal={
        idnumber:0,
        idnumber1:0,
        idnumber2:0,
        idnumber3:0
      }
      for(let i=0;i<surplus.post_push_point_surplus.length;i++){
        if(this.city_value==surplus.post_push_point_surplus[i].province){
          this.modal.idnumber2=surplus.post_push_point_surplus[i].surplus
        }
      }
      for(let i=0;i<surplus.post_refresh_point_surplus.length;i++){
        if(this.city_value==surplus.post_refresh_point_surplus[i].province){
          this.modal.idnumber1=surplus.post_refresh_point_surplus[i].surplus
        }
      }
      for(let i=0;i<surplus.post_top_point_surplus.length;i++){
        if(this.city_value==surplus.post_top_point_surplus[i].province){
          this.modal.idnumber=surplus.post_top_point_surplus[i].surplus
        }
      }
      for(let i=0;i<surplus.resume_download_num_surplus.length;i++){
        if(this.city_value==surplus.resume_download_num_surplus[i].province){
          this.modal.idnumber3=surplus.resume_download_num_surplus[i].surplus
        }
      }
      this.distributionFormDialogShow = true
    },

    dataFlas(arr,surplus){
      this.formModal={
        idnumber:0,
        idnumber1:0,
        idnumber2:0,
        idnumber3:0
      }
      if(!arr||arr.length==0){
        this.formModal={
          idnumber:0,
          idnumber1:0,
          idnumber2:0,
          idnumber3:0
        }
      }else{
        if(arr.post_top_point.length>0){
          for(let i=0;i<arr.post_top_point.length;i++){
            if(this.city_value==arr.post_top_point[i].province){
              this.formModal.idnumber=arr.post_top_point[i].surplus
            }
          }
        }
        if(arr.post_refresh_point.length>0){
          for(let i=0;i<arr.post_refresh_point.length;i++){
            if(this.city_value==arr.post_refresh_point[i].province){
              this.formModal.idnumber1=arr.post_refresh_point[i].surplus
            }
          }
        }
        if(arr.post_push_point.length>0){
          for(let i=0;i<arr.post_push_point.length;i++){
            if(this.city_value==arr.post_push_point[i].province){
              this.formModal.idnumber2=arr.post_push_point[i].surplus
            }
          }
        }
        if(arr.resume_download_num.length>0){
          for(let i=0;i<arr.resume_download_num.length;i++){
            if(this.city_value==arr.resume_download_num[i].province){
              this.formModal.idnumber3=arr.resume_download_num[i].surplus
            }
          }
        }        
      }
      this.modal={
        idnumber:0,
        idnumber1:0,
        idnumber2:0,
        idnumber3:0
      }
      for(let i=0;i<surplus.post_push_point_surplus.length;i++){
        if(this.city_value==surplus.post_push_point_surplus[i].province){
          this.modal.idnumber2=surplus.post_push_point_surplus[i].surplus
        }
      }
      for(let i=0;i<surplus.post_refresh_point_surplus.length;i++){
        if(this.city_value==surplus.post_refresh_point_surplus[i].province){
          this.modal.idnumber1=surplus.post_refresh_point_surplus[i].surplus
        }
      }
      for(let i=0;i<surplus.post_top_point_surplus.length;i++){
        if(this.city_value==surplus.post_top_point_surplus[i].province){
          this.modal.idnumber=surplus.post_top_point_surplus[i].surplus
        }
      }
      for(let i=0;i<surplus.resume_download_num_surplus.length;i++){
        if(this.city_value==surplus.resume_download_num_surplus[i].province){
          this.modal.idnumber3=surplus.resume_download_num_surplus[i].surplus
        }
      }
    },
    handleViewInfo(row,title,num,product_type){
      console.log(row);
      this.$axios
        .post("/recruitment/company/distribute_province_record", {
          product_type:product_type,
          id:row.id,
          page_flag:0,
          total_flag:0,
        })
        .then((res) => {
          console.log(res.data.items);
          this.tableData=res.data.items
          if(this.tableData.length==0){
            this.tableData=[{province:'全国',surplus:0}]
          }else{
            this.tableData.map(item=>{
              if(item.province==''){
                item.province='全国'
              }
            })
          }          
        });
      this.numberName=title
      this.numberFlag=true;      
      num!=0?this.numberSurplus=num:this.numberSurplus=0
    },
    async handleBtnInfo(item, type) {
      this.info = item;
      this.numberFlag=false;      
      switch (type) {
        case "create":
          //点击添加新成员
          this.formDialogShow = true;
          break;
        case "deliver":
          this.deliverFormDialogShow = true;
          break;
        case "distribution":
          // eslint-disable-next-line no-case-declarations
          let parme={
            type:2
          }
          await this.$axios.post('/recruitment/config/province_city',parme).then((res) => {  
            this.city_options=res.data.items.map(item=>({'label':item.province,'value':item.province}));
            this.city_options.unshift({
              value: '',
              label: "全国",
            });
          })
          if(this.userInfo.id ===item.user_id){
            this.$message({
              showClose: true,
              message: '管理员不能给自己分配权益！',
              type: 'error'
            })
          }else{
            await this.loadProduct(item.id,item.user_id);
            this.distributionTitle = `为${item.recruit_name}分配招聘权益用量`;
            await this.distributeRightsDetail(item.id)
            // this.distributionFormConfig = distributionFormConfig(this.detail, {
              // id: item.post_refresh_point === -1 ? 1 : 2,
              // id1: item.post_top_point === -1 ? 1 : 2,
              // id2: item.resume_download_num === -1 ? 1 : 2,
              // id3: item.post_push_point === -1 ? 1 : 2,
              // idnumber:item.post_refresh_point,
              // idnumber1:item.post_top_point,
              // idnumber2:item.resume_download_num,
              // idnumber3:item.post_push_point,
            // });
          }
          break;
        case "delete":
          this.deleteTitle = `确认要将${item.recruit_name}移出企业吗`;
          this.delDialogShow = true;
          break;
        default:
          break;
      }
    },
    async handleConfirm(type, data) {
      console.log(data)
      switch (type) {
        case "create":
          //点击添加新成员
          try {
            await this.$axios.post("/recruitment/company/add_employer", data);
            this.$success("添加新成员成功");
            this.loadUsers();
            this.$refs["InfoAccount"].$refs.formCustom.handleExpectQuery();
          } catch (err) {
          
            if (err.data.code === "Error5101001") {
              this.$confirm(
                this.userInfo.company.member_level === 1?
                "企业所绑定的招聘账号已达上限，开通招聘PLUS会员，可绑定更多账号，如需开通请联系服务顾问"
                :
                "企业所绑定的招聘账号已达上限，如需继续添加，请先移出成员，如需咨询可联系顾问"
                ,
                "",
                {
                  confirmButtonText: "联系顾问",
                  cancelButtonText: "取消",
                  type: "",
                }
              )
                .then(() => {
                  this.$bus.$emit("openCustomer");
                })
                .catch(() => {});
            }

            return Promise.reject(false);
          }
          break;
        case "deliver":
          try {
            await this.$axios.post("/recruitment/company/transfer_admin", {
              id: data.id[0],
            });
            this.$success("管理员已转交");
            location.reload();
            // this.$refs["InfoAccount"].$refs.formCustom.handleExpectQuery();
          } catch (err) {
            return Promise.reject(false);
          }
          break;



        case "distribution":
            if (data.idnumber) {
              // this.$fail(`请填写职位置顶点的分配数量`);
              // return Promise.reject(false);
              if (
                !validateInputNumber(data.idnumber, 8, true) ||
                !validateInputInteger(data.idnumber)
              ) {
                this.$fail(`请填写正确的职位置顶点的分配数量`);
                return Promise.reject(false);
              }
              if (data.idnumber > this.detail.surplus.post_top_point_surplus + this.detail.quota.post_top_point) {
                this.$fail(
                  `职位置顶点最多只能分配${this.detail.surplus.post_top_point_surplus + this.detail.quota.post_top_point}`
                );
                return Promise.reject(false);
              }
            }
            

            if (data.idnumber1) {
              // this.$fail(`请填写职位刷新点的分配数量`);
              // return Promise.reject(false);
              if (
                !validateInputNumber(data.idnumber1, 8, true) ||
                !validateInputInteger(data.idnumber1)
              ) {
                this.$fail(`请填写正确的职位刷新点的分配数量`);
                return Promise.reject(false);
              }
              if (
                data.idnumber1 > this.detail.surplus.post_refresh_point_surplus+this.detail.quota.post_refresh_point
              ) {
                this.$fail(
                  `职位置刷新点最多只能分配${this.detail.surplus.post_refresh_point_surplus+this.detail.quota.post_refresh_point}`
                );
                return Promise.reject(false);
              }
            }
            

            if (data.idnumber2 ) {
              let reg = /^[0-9]+([.]{1}[0-9]{0,1})?$/;
              if (!reg.test(data.idnumber2)) {
                this.$fail(`请填写正确的职位省心推上限的分配数量`);
                return Promise.reject(false);
              }
              // if (
              //   !validateInputNumber(data.idnumber2) ||
              //   !validateInputInteger(data.idnumber2)
              // ) {
              //   this.$fail(`请填写正确的职位省心推上限的分配数量`);
              //   return Promise.reject(false);
              // }
              if (
                data.idnumber2 >
                this.detail.surplus.post_push_point_surplus+this.detail.quota.post_push_point
              ) {
                this.$fail(
                  `职位省心推上限最多只能分配${this.detail.surplus.post_push_point_surplus+this.detail.quota.post_push_point}`
                );
                return Promise.reject(false);
              }
            }
            

            if (data.idnumber3 ) {
              // this.$fail(`请填写简历下载点的分配数量`);
              // return Promise.reject(false);
              if (
                !validateInputNumber(data.idnumber3, 8, true) ||
                !validateInputInteger(data.idnumber3)
              ) {
                this.$fail(`请填写正确的简历下载点的分配数量`);
                return Promise.reject(false);
              }
              if (
                data.idnumber3 >
                this.detail.surplus.resume_download_num_surplus+this.detail.quota.resume_download_num
              ) {
                this.$fail(
                  `简历下载点最多只能分配${this.detail.surplus.resume_download_num_surplus+this.detail.quota.resume_download_num}`
                );
                return Promise.reject(false);
              }
            }
          try {
            let parme={
              id: this.info.id+"",
              'post_top_point': [{'province':this.city_value,'num':data.idnumber?data.idnumber:0}],
              'post_refresh_point':  [{'province':this.city_value,'num':data.idnumber1?data.idnumber1:0}],
              'post_push_point':  [{'province':this.city_value,'num':data.idnumber2?data.idnumber2:0}],
              'resume_download_num': [{'province':this.city_value,'num':data.idnumber3?data.idnumber3:0}],
            }
            console.log(parme)
            await this.$axios.post("/recruitment/company/distribute_rights", parme)
            this.loadProduct();
            this.$refs["InfoAccount"].$refs.formCustom.handleExpectQuery();
            this.distributionFormDialogShow=false;
          } catch (err) {
            return Promise.reject(false);
          }
          break;
        case "delete":
          try {
            await this.$axios.post("/recruitment/company/remove_employer", {
              id: this.info.id,
            });
            this.$success("操作成功");
            this.$refs["InfoAccount"].$refs.formCustom.handleExpectQuery();
          } catch (err) {
            return Promise.reject(false);
          }
          break;
        case "copy":
          this.$copyText("zp.dcthq.com").then(() => {
            this.$success("链接已复制");
          });
          break;
        default:
          break;
      }
    },

    //筛选前钩子
    paramsFormatter(condition, pagination) {
      return {
        ...condition,
        pageInfo: pagination,
      };
    },
  },
};
</script>


<style lang="scss">
@import "./index.scss";
</style>
